export const projectContents = {
  harmonii: {
    description: (
      <div>
        <p>
          <b
          >
            harmonii
          </b>{" "}
          aims to create a social music-sharing platform where users can contribute and curate their own library of songs.
        </p>
        <p>
          <br />
          Developed with Asp.Net Core, MsSQL, JavaScript, React.js, CSS and more
        </p>
      </div>
    ),
  },
  lifemap: {
    description: (
      <div>
        <p>
          <b
            style={{
              color: "#abc4ff",
            }}
          >
            lifemap
          </b>{" "}
          is a powerful life tracking platform designed to help you stay
          organized and achieve your goals
        </p>
        <p>
          <br />
          Developed with JavaScript, React.js, CSS, Material UI,
          styled-components and more
        </p>
      </div>
    ),
  },
  dhondtApp: {
    description: (
      <div>
        <p>
          <b>D'Hondt System Calculator</b> is a website designed to help you
          understand and apply the D'Hondt system for parliamentary seat
          allocation.
        </p>
        <p>
          <b>D'Hondt System:</b> The D'Hondt system is a method for distributing
          parliamentary seats based on the proportion of votes received by
          candidates or parties in elections. It involves a series of division
          operations on the total vote count in the electoral district to
          allocate parliamentary seats.
          <br />
          <br />
          Developed with JavaScript, React.js, CSS, styled-components
        </p>
      </div>
    ),
  },
};
